export default __webpack_public_path__ + "static/media/icon-03.f73068ec.svg";